const ArrowFix: React.FC<{ rotate?: number; fill?: string; className?: string }> = ({
    rotate = 0,
    fill = '#646464',
    className = '',
}) => {
    return (
        <svg
            className={className}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            style={{ transform: `rotate(${rotate}deg)` }}
        >
            <path
                d="M8.78135 5.33333L5.20535 1.75733L6.14802 0.814667L11.3334 6L6.14802 11.1853L5.20535 10.2427L8.78135 6.66667L0.666687 6.66667L0.666687 5.33333L8.78135 5.33333Z"
                fill={fill}
            />
        </svg>
    );
};

export default ArrowFix;
